import { lazy } from 'react';

export const ErrorBoundary = lazy(() => import('@/shared/components/common/ErrorBoundary'));
